import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from '../Panel/Panel.jsx';
import { FormControl } from '../material-ui/FormControl';
import { FormHelperText } from '../material-ui/FormHelperText';
import { MenuItem } from '../material-ui/Menu';
import { Select } from '../material-ui/Select';
import { Typography } from '../material-ui/Typography';
import PilotFlight from '../../icons/image/PilotFlight';
import { sortCrewByName } from '../../service/sort';
import { getTranslateText } from '../../service/utils';
import { useStyles } from './useStyles';

import '../ActionTimeControl/ActionTimeControl.scss';

export const SelectCrewPanel = memo((props) => {
    const { title, className, value, isRequired, onChange } = props;
    const isError = isRequired && !value;
    const { t: translate } = useTranslation();
    const error = isError ? translate('errors.validate.fieldIsRequired') : '';
    const classes = useStyles();

    const handleChange = React.useCallback((event) => {
        onChange(event.target.value);
    }, []);

    const items = React.useMemo(() => (props.items && props.items.sort(sortCrewByName)) || [], [props.items]);

    return (
        <Panel title={title} className={className} leftIcon={<PilotFlight width="30" height="30" />}>
            <div className={classes.content}>
                <FormControl error={isError}>
                    <Select value={value || 0} onChange={handleChange} autoWidth={false} className={classes.select}>
                        <MenuItem value={0} key={0}>
                            <Typography>{translate('notSelected')}</Typography>
                        </MenuItem>
                        {items.map((item) => (
                            <MenuItem value={item.crewId} key={item.crewId}>
                                <Typography>{getTranslateText('fullName', item)}</Typography>
                            </MenuItem>
                        ))}
                    </Select>
                    {isError && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            </div>
        </Panel>
    );
});
